import { Box, Typography } from "@mui/material";
import BaseButton from "../../BaseButton";

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CloseIcon from '@mui/icons-material/Close';

export default function ConfirmStaffModal({ close, data }) {
  const { staff_name, staff_role, patient_name, confirm_type, onConfirm = () => { }, loadingConfirm = false } = data

  const handleClickConfirm = async () => {
    if (onConfirm) {
      await onConfirm()
    }
    close()
  }

  return (
    <Box sx={{
      width: '585px',
      height: '251px',
      borderRadius: '16px',
      boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.04)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'white',
      overflow: 'hidden',
    }}>
      <Box
        sx={{
          width: '100%',
          height: '175px',
          padding: '32px 20px 0px 20px',
        }}>
        <Typography
          variant="h3"
          sx={{
            textAlign: 'center'
          }}
        >
          You are about to make a change to this Patient's Medical Staff
        </Typography>
        <Box
          sx={{
            mt: '20px'
          }}
        >
          <Typography
            variant="h3"
            sx={{
              color: confirm_type ? 'primary.red' : 'primary.black',
            }}
          >
            Are you sure you want to {confirm_type ? 'remove' : 'add'} {staff_name} as {staff_role} from {patient_name}’s medical staff?
          </Typography>
        </Box>
      </Box>
      <Box sx={{
        borderTop: '1px solid #CCCCCC',
        width: '100%',
        height: '76px',
        padding: '8px',
        bgcolor: 'primary.darkGray',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',        
      }}>
        <Box>
          <BaseButton
            buttonType="default"
            height={'44px'}
            onClick={close}
            sx={{
              borderRadius: '100px',
            }}
          >
            <CloseIcon
              sx={{
                mr: '16px',
              }} />
            <Typography variant="body">
              Cancel
            </Typography>
          </BaseButton>
        </Box>
        <Box>
          <BaseButton
            buttonType="primary"
            height={'44px'}
            onClick={handleClickConfirm}
            loading={loadingConfirm}
            sx={{
              borderRadius: '100px',
            }}
          >
            <Typography
              variant="body"
              sx={{
                mr: '16px',
              }}>
              Confirm
            </Typography>
            <ArrowForwardIosIcon />
          </BaseButton>
        </Box>
      </Box>
    </Box >
  )
}